import { render, staticRenderFns } from "./ClubInfoModal.vue?vue&type=template&id=e427aa62&"
import script from "./ClubInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClubInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e427aa62')) {
      api.createRecord('e427aa62', component.options)
    } else {
      api.reload('e427aa62', component.options)
    }
    module.hot.accept("./ClubInfoModal.vue?vue&type=template&id=e427aa62&", function () {
      api.rerender('e427aa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/desktop/ClubInfoModal.vue"
export default component.exports